import { useRecoilValue } from "recoil";
import { PubMemberDto } from "../../../../../../api/member";
import { pubState } from "../../../../../../recoil/pub.atom";
import { MileageButtonWrapper, MileageHeader } from "../../style";
import MileageMenuList from "./components/menu-list";
import { useEffect, useState } from "react";
import MenuManage from "./components/menu-manage";
import {
  MileageMenuPayMany,
  MileageMenuPayRequest,
  MileageMenuResponse,
  getMileageMenu,
} from "../../../../../../api/pub-product";
import { MileageBuyWrapper } from "./style";
import MileageBuyList from "./components/buy-list";
import { Title } from "../../../../../../styles/page";

interface MileageBuyProps {
  onClose: () => void;
  member: PubMemberDto | null;
}
const MileageBuy = ({ onClose, member }: MileageBuyProps) => {
  const pub = useRecoilValue(pubState);
  const [list, setList] = useState<MileageMenuResponse[]>([]);
  const [selectMenus, setSelectMenus] = useState<MileageMenuResponse[]>([]);

  const getData = async () => {
    if (!pub) return;
    try {
      const res = await getMileageMenu(pub.id);
      setList(res);
    } catch {
      setList([]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handlePay = async () => {
    if (!member) return;
    const total = selectMenus.reduce((acc, item) => acc + item.price, 0);
    if (member.point < total) {
      alert("보유 마일리지가 부족합니다. ");
      return;
    }
    try {
      const data: MileageMenuPayRequest[] = [];
      selectMenus.forEach(async (item) => {
        data.push({
          memberId: member.memberId,
          pubProductId: item.id,
        });
      });
      await MileageMenuPayMany(data);
    } catch {
      alert("재시도 해주세요.");
    }
    alert("구매되었습니다. ");
    onClose();
  };

  return (
    <>
      <MileageBuyWrapper>
        <MileageHeader>
          <Title size={20}>주류M 구입</Title>
          <div className="right">
            <div className="name">
              보유 마일리지 <span>{member?.point.toLocaleString()}</span>
            </div>
          </div>
        </MileageHeader>
        <MileageMenuList
          allList={list}
          setSelectMenus={setSelectMenus}
          selectMenus={selectMenus}
          member={member}
        />
        <MileageBuyList
          selectMenus={selectMenus}
          setSelectMenus={setSelectMenus}
        />
        <MileageButtonWrapper>
          <div
            className="button purple"
            onClick={() => {
              handlePay();
            }}
          >
            적용
          </div>
          <div
            className="button"
            onClick={() => {
              onClose();
            }}
          >
            취소
          </div>
        </MileageButtonWrapper>
      </MileageBuyWrapper>
    </>
  );
};

export default MileageBuy;
